import React, { useContext } from 'react'

import { CampaignManagerContext } from '~/service/CampaignManager'
import CallButton from '~/components/common/CallButton'

type SubmitProps = {
  isSubmitting: boolean
}

const Submit: React.FC<SubmitProps> = ({ isSubmitting }) => {
  const campaignContext = useContext(CampaignManagerContext)
  const campaign = campaignContext.activeCampaign

  return (
    <div className="main-content-stickyButton call-show-submit">
      {campaign ? (
        <CallButton next type="submit" disabled={isSubmitting} />
      ) : (
        <CallButton save type="submit" disabled={isSubmitting} />
      )}
    </div>
  )
}

export default Submit
